import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { overlay } from "overlay-kit";
import { AlertModal } from "components/modal/AlertModal";
import { useNaverLoginMutation } from "../../service/hooks/mutations";
import { select_access_token } from "http/TokenConn";
import { fn_init_info } from "function/FnBodyInit";
import { useNaverShopSearchQuery } from "../../service/hooks/queries";

const NaverCallback = inject("rootStore")(
  observer(({ rootStore }: any) => {
    const { searchStore } = rootStore;
    const history = useHistory();
    const location = useLocation();
    const shopCd = searchStore.getShopCd;
    const naverUniqueId = searchStore.getNaverUniqueId;
    const { mutate: naverLogin } = useNaverLoginMutation(rootStore);
    const { refetch: fetchNaverShopSearch } = useNaverShopSearchQuery(
      rootStore,
      {
        shopCd,
        page: 1,
        size: 5,
        includeNpayUnregistered: true,
      },
      { enabled: !!naverUniqueId }
    );

    useEffect(() => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const error = urlParams.get("error");

      if (error || !code || state !== "naver_login") {
        history.push("/setting/default/receipt");
        return;
      }

      // 네이버 로그인 처리
      const handleNaverLogin = async () => {
        await fn_init_info(rootStore);
        naverLogin(
          { code, state },
          {
            onSuccess: async data => {
              const uniqueId = data?.data?.id ?? "";
              searchStore.setNaverUniqueId(uniqueId);

              const shopInfo = await fetchNaverShopSearch();
              if (shopInfo?.data?.data?.metadata?.connectedCount! > 0) {
                history.push("/naver/connected");
              } else {
                history.push("/naver/disconnected");
              }
            },
            onError: error => {
              overlay.open(({ isOpen, close }) => (
                <AlertModal
                  open={isOpen}
                  title="로그인에 실패했어요"
                  subTit1="네트워크 문제로 로그인에 실패했어요"
                  subTit2="잠시 후 다시 시도해주세요."
                  rightBtnOnClick={() => {
                    close();
                    history.push("/setting/default/receipt");
                  }}
                  rightBtnVariant="secondaryPrimary"
                  rightBtnTxt="닫기"
                />
              ));
            },
          }
        );
      };

      handleNaverLogin();
    }, []);

    return <></>;
  })
);

export default NaverCallback;
